import React from "react";
import PropTypes from "prop-types";
import { useLocation, useNavigate } from "react-router-dom";

function PhotoGallery({ productPhotos, photo, open }) {
  const navigate = useNavigate();
  const path = useLocation().pathname;

  const selectPhotoHandler = (productPhoto) => {
    photo(productPhoto);
    open(true);
  };

  return (
    <section className="w-full">
      <div className="grid grid-cols-4 gap-2.5">
        {productPhotos
          .slice(0, path !== "/products" ? 8 : productPhotos.length)
          .map((item) => (
            <button
              type="button"
              className="relative rounded-lg overflow-hidden h-[78px] md:h-[200px] flex grow"
              onClick={() => selectPhotoHandler(item)}
              key={item.id}
            >
              <img
                alt={item.title || item.product_name}
                className="block object-cover w-full h-full"
                src={item.business_photo || item.photo_url}
                title={item.title || item.product_name}
              />
            </button>
          ))}
      </div>
      {productPhotos.length > 8 && path !== "/products" && (
        <button
          type="button"
          onClick={() => navigate("/products")}
          className="text-purple-50 text-sm font-normal h-4"
        >
          {productPhotos.length >= 8 && "See more"}
        </button>
      )}
    </section>
  );
}

PhotoGallery.defaultProps = {
  productPhotos: [],
};

PhotoGallery.propTypes = {
  productPhotos: PropTypes.arrayOf(PropTypes.objectOf(PropTypes.any)),
  photo: PropTypes.func.isRequired,
  open: PropTypes.func.isRequired,
};
export default PhotoGallery;
